import { defineStore } from 'pinia'
import { useSkeleton } from './skeleton';
export const useCash = defineStore('cash', {
    state: () => {
        return {
            banners: [],
            mainCategories: [],
            homeGroups: [],
            shops: [],
            mainVectors: [],
            suppliers: {},
            products: {}
        }
    },
    getters: {
    },
    actions: {
        async getBanners() {
            if (!this.banners.length) {
                const skeleton = useSkeleton()
                skeleton.banners = false;
                let response = await fetch("https://radap.ir/Backend/api/section/pages/main/banner.php")
                let data = await response.json()
                this.banners = data;
                skeleton.banners = true;
            }
        },
        async getMainCategories() {
            if (!this.mainCategories.length) {
                const skeleton = useSkeleton()
                skeleton.mainCategories = false;
                let response = await fetch('https://radap.ir/Backend/api/section/pages/main/main_categories.php')
                let data = await response.json()
                this.mainCategories = data
                skeleton.mainCategories = true;
            }
        },
        async getHomeGroups(type) {
            if (!this.homeGroups.length || type == 'home') {
                const skeleton = useSkeleton()
                if (type != 'home') {
                    skeleton.homeGroups = false;
                }
                let response = await fetch("https://radap.ir/Backend/api/section/pages/main/groups.php")
                let data = await response.json()
                this.homeGroups = data
                skeleton.homeGroups = true;
            }
        },
        async getShops(id) {
            if (!this.shops[id] || !this.shops[id].length) {
                const skeleton = useSkeleton()
                skeleton.shops = false;
                const response = await fetch(`https://radap.ir/Backend/api/section/pages/shops/list.php?catId=${id}`)
                const data = await response.json()
                this.shops[id] = data.items;
                this.mainVectors[id] = [
                    {
                        fa: data.vector.name,
                        path: '/Shops/' + data.vector.id
                    }
                ]
                skeleton.shops = true;
            }
        },
        async getDetail(id) {
            if (!this.suppliers[id] || !Object.keys(this.suppliers[id]).length) {
                const skeleton = useSkeleton()
                skeleton.storeDetail = false;
                let response = await fetch(`https://radap.ir/Backend/api/section/pages/store/getDetail_new.php?id=${id}`)
                let data = await response.json()
                this.suppliers[id] = {
                    name: data.name,
                    lat: data.lat,
                    lang: data.lang,
                    address: data.address,
                    description: data.description,
                    store_img1: data.store_img1,
                    track_time: data.track_time,
                    delivery_cost: data.delivery_cost,
                    template_type: data.template_type,
                    min_sale: data.min_sale,
                    category: data.category,
                    secret: data.secret,
                    type_products: data.type_products,
                    categoryFa: data.category_fa,
                    timing: data.timing,
                    close: data.close,
                    absoluteTimeTxt: data.absoluteTimeTxt,
                };
                skeleton.storeDetail = true;

            }
        },
        async getProducts(id, type) {
            if (!this.products[id] || !Object.keys(this.products[id]).length || type == 'interval') {
                const skeleton = useSkeleton()
                if (type != 'interval') {
                    skeleton.storeProduct = false;
                }
                let response = await fetch(`https://radap.ir/Backend/api/section/pages/store/getProducts.php?id=${id}`)
                let data = await response.json()
                this.products[id] = {
                    groups: data.group,
                    damp: data.damp,
                    best: data.best,
                    ordinations: data.ordination
                }
                this.products[id].groups = data.group;
                this.products[id].damp = data.damp;
                this.products[id].best = data.best;
                this.products[id].ordinations = data.ordination;
                skeleton.storeProduct = true;
            }

        }
    }
})